import localStorageProvider from '../Providers/LocalStorageProvider';

import polyglotI18nProvider from 'ra-i18n-polyglot';

import customPortugueseMessages from './Custom/pt';

import portugueseBrasilMessages from 'ra-language-pt-br';
import customPortugueseBrasilMessages from './Custom/pt-br';

import englishMessages from 'ra-language-english';
import customEnglishMessages from './Custom/en-us';

export const AvailableLanguages = [
    {
        language: 'pt',
        name: 'Portugues (PT)',
        countryCode: 'PT',
        messages: { ...portugueseBrasilMessages, ...customPortugueseMessages }
    },
    {
        language: 'pt-br',
        name: 'Portugues (BR)',
        countryCode: 'BR',
        messages: { ...portugueseBrasilMessages, ...customPortugueseBrasilMessages }
    },
    {
        language: 'en-us',
        name: 'English',
        countryCode: 'US',
        messages: { ...englishMessages, ...customEnglishMessages }
    }
]

const lastLanguage = localStorageProvider.getItem('last-language');

const i18nProvider = polyglotI18nProvider(locale => {
    let language = AvailableLanguages.find(language => language.language === locale);

    if (!language || !language.messages) {
        return AvailableLanguages[0].messages;
    }

    return language.messages;
}, lastLanguage || 'pt');

export default i18nProvider;